import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import moment from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';
import { AppService } from 'src/app/core/services/app.service';
import { CommandCenterService } from 'src/app/core/services/command-center.service';
import { FocuslinkService } from 'src/app/core/services/focuslink.service';
import { LocalDataStoreService } from 'src/app/core/services/local-data-store.service';
import { NavigationService } from 'src/app/core/services/navigation.service';
import { UserService } from 'src/app/core/services/user.service';
import { UserStatusEnum } from 'src/app/shared/models/enums/user-status.enum';
import { User } from 'src/app/shared/models/user.model';

@Component({
	selector: 'app-user-login',
	templateUrl: './user-login.component.html',
	styleUrls: ['../commandCenter/commandcenter.scss'],
})
export class UserLoginComponent implements OnInit, OnDestroy {
	errorCondition: string = undefined;
	forgotPassword: boolean = false;
	maintenanceCycle: boolean = false;
	moment: any = moment;

	user = {
		email: undefined,
		password: undefined,
	};

	constructor(
		@Inject(DOCUMENT) private document: Document,
		public app: AppService,
		private localStorage: LocalDataStoreService,
		private focuslink: FocuslinkService,
		private route: ActivatedRoute,
		private router: Router,
		private userService: UserService,
		private navigationService: NavigationService,
		private spinner: NgxSpinnerService,
		private titleService: Title,
		private commandCenter: CommandCenterService
	) {}

	ngOnInit() {
		this.titleService.setTitle('Focus CommandCenter');
		this.userService.logout();
		this.init();
	}

	ngOnDestroy() {}

	async init() {}

	async resetPasswordRequest() {
		await this.focuslink.userPasswordReset(this.user.email);
		this.errorCondition = 'Password reset request has been submitted. If you have a valid FocusOnline user account, you will receive an email shortly.';
	}

	goTo(destination): void {
		this.document.location.href = destination;
	}

	async login() {
		this.app.loading(true);
		try {
			const resp = await this.focuslink.userLogIn(this.user.email, this.user.password);

			const user: User = new User(resp.user);
			switch (user.status) {
				case UserStatusEnum.ACTIVE:
					console.log('user is active');
					await this.userService.initUser(user, resp.token);
					this.router.navigate([this.userService.userSubscription.value.preferences.menuDefault]);
					break;
				case UserStatusEnum.DELETED:
					this.errorCondition = 'User account has been deleted';
					break;
				case UserStatusEnum.FROZEN:
					this.errorCondition = 'Sorry, your user account is frozen';
					break;
			}

			this.commandCenter.initCommandCenter();
		} catch (error) {
			console.log(error);
			this.app.msgSvc.add({ severity: 'error', summary: 'Oops!', detail: error.error.error });
			this.errorCondition = error.error.error;
			this.spinner.hide();
		}
	}
}
